var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import moment from "moment";
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import RateDialog from '../CreateDialogue/RateDialog';
import EditRateDialog from '../EditDialogue/EditRateDialog';
import { muiThemeDesign } from '../../mui-theme-design';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import {logger, customBodyForExcelReport,handleExport,permissions,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');

export default function RateTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [rates, setRates] = React.useState([]);
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(true);
    const [expand, setExpand] = React.useState(false);

    const handleDialogCallback = async (childData) => {
        const out = await fetch("api/rate", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "rate": [{
                    "SOWID": childData.SOWID,
                    "PositionID": childData.PositionID,
                    "Rate": childData.Rate,
                    "StartDate": childData.StartDate,
                    "EndDate": childData.EndDate
                }]
            })
        }).then(res => res.json()
        ).then(json => {
            if (json.code == 'ER_DUP_ENTRY') {
                setAlertText("Duplicate entry")
                setAlert(true)
                return false
            } else {
                return true
            }
        })

        logger(childData);
        setRefresh(true)
        return out
    };

    const handleEditCallback = (childData) => {
        fetch("api/rate", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "rate": {
                    "ID": childData.ID,
                    "SOWID": childData.SOWID,
                    "PositionID": childData.PositionID,
                    "Rate": childData.Rate,
                    "StartDate": childData.StartDate,
                    "EndDate": childData.EndDate
                }
            })
        })
        logger(childData);
        setRefresh(true)
    };

    const handleAlertClose = () => {
        setAlert(false);
    };
    
    React.useEffect(() => {
        
        if (refresh) {
            fetch(`api/rate/${expand}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
					setRates(json);
					setIsLoading(false);
				})

            setRefresh(false)
        }
    })
    
    
      const columns = [];
    if (permissions.CreateRate == 1) {
       	const adminActions =  {
            name: "Admin Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                print: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
					var rateData = {
					    "ID": rates[dataIndex].ID,
					    "SOWID": rates[dataIndex].SOWID,
					    "PositionID": rates[dataIndex].PositionID,
					    "SOW": rates[dataIndex].SOW,
					    "Position": rates[dataIndex].Position,
					    "Rate": rates[dataIndex].Rate
					};
					const byteArray = new Uint8Array(rateData.Rate.data);
					const textDecoder = new TextDecoder();
					const res = textDecoder.decode(byteArray);
					const r = parseFloat(res).toFixed(2);
					rateData.Rate = r;
                    return (
                        <div>
                            <EditRateDialog handleEditCallback={handleEditCallback} data={rateData} />
                        </div>
                    );
                }

            }
        };
        columns.push(adminActions);
    }
     const columns1 = [
        {
            name: "SOW",
            label: "SOW",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Position",
            label: "Position",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Rate",
            label: "Rate",
            options: {
                filter: false,
                sort: true,
				customBodyRenderLite: (dataIndex, rowIndex) => {
					if (rates[dataIndex].Rate === "****") {
						return (
							rates[dataIndex].Rate
						)
					} else {
						const byteArray = new Uint8Array(rates[dataIndex].Rate.data);
						const textDecoder = new TextDecoder();
						const res = textDecoder.decode(byteArray);
						return (
							parseFloat(res).toFixed(2)
						);
					}
				}
            }
        },
    ];
    
    columns.push(...columns1);

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('RaterowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('RaterowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();
	
  const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
      selectableRows: 'none',
      rowsPerPage: initialRowsPerPage,
      rowsPerPageOptions: [10, 20, 50, 100],
      textLabels: {
			toolbar: {
				search: "Search",
				downloadCsv: "Download Excel",
				print: "Print",
				viewColumns: "View Columns",
				filterTable: "Filter Table",
			},
		},
		onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}

			const customBuildBody = () => {
				const headers = customBuildHead();
				
				for (var i = 0; i < data.length; i++) {
					var eachRow = data[i].data;
					var payRate = eachRow[3];
					const byteArray = new Uint8Array(payRate.data);
					const textDecoder = new TextDecoder();
					const res = textDecoder.decode(byteArray);
					eachRow[3] = res;
				}		
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};

			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename:'Rates.xlsx', columnIndexToRemove:0});
			return false;
		},
		customToolbar: () => permissions.CreateRate===1 && !isLoading ? (<div>
			<FormControlLabel
				name="Expand"
				label="Expand"
				style={{ color: 'white' }}
                control={
                    <Tooltip title="show rates without active sow">
                    <Checkbox
					checked={expand}
					labelStyle={{ color: 'white' }}
					iconStyle={{ fill: 'white' }}
					inputStyle={{ color: 'white' }}
					style={{ color: 'white' }}
					onChange={e => {
						setExpand(!expand)
						setRefresh(true)
                            }} />
                    </Tooltip>
                        }
			/>
			<RateDialog handleDialogCallback={handleDialogCallback} />
		</div>):(<></>)
	};

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (       
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="RatesTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Rate
                        </Typography>
                    }
                    data={isLoading ? [] :rates}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}
                    
                />
                </Box>
            </MuiThemeProvider>
            <Dialog
                open={LockedAlert}
                onClose={handleAlertClose}
                aria-labelledby="L&P Lock"
                aria-describedby="Time Period locked for this work"
            >
                <DialogTitle id="Time Entry">
                    {"Alert"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {AlertText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
        
    );
}  
